// extracted by mini-css-extract-plugin
export var fullWidthButton = "_ho-0";